import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CRMAtividade } from 'src/app/models/crm/crmatividade';
import { CRMLogOportunidade } from 'src/app/models/crm/crmlog-oportunidade';
import { CRMOportunidade } from 'src/app/models/crm/crmoportunidade';
import { TipoLogOportunidade } from 'src/app/models/enum';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmlogOportunidadeService } from 'src/app/services/crm/crmlog-oportunidade.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-log-oportunidade',
  templateUrl: './log-oportunidade.component.html',
  styleUrls: ['./log-oportunidade.component.scss']
})
export class LogOportunidadeComponent implements OnInit {
  idOportunidade: number;
  idAtividade: number;

  oportunidade: CRMOportunidade;
  atividade: CRMAtividade;

  titulo = '';

  datePipe = new DatePipe('pt-BR');

  logs: CRMLogOportunidade[] = [];

  TipoLogOportunidade = TipoLogOportunidade;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<LogOportunidadeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private notificacaoService: NotificacaoService,
    private logService: CrmlogOportunidadeService, private carregandoService: CarregandoService
  ) { }

  ngOnInit() {
    this.idOportunidade = this.data.idOportunidade;
    this.idAtividade = this.data.idAtividade;
    this.oportunidade = this.data.oportunidade;
    this.atividade = this.data.atividade;

    this.buscarLogs();
  }

  buscarLogs() {
    this.carregandoService.mostra('buscarLogs');

    this.logService.consultarLogsPorOportunidade(this.idOportunidade, this.idAtividade).subscribe(resp => {
      this.logs = resp;
      this.logs.forEach(l => {
        this.defineCorIcone(l);
      });
      this.carregandoService.esconde('buscarLogs');
    }, (erro) => {
      this.carregandoService.esconde('buscarLogs');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  formataData(data, formato) {
    return this.datePipe.transform(new Date(data), formato);
  }

  defineCorIcone(log: CRMLogOportunidade) {
    switch (log.tipo) {
    case TipoLogOportunidade.AlterouEtapa:
      log.icone = 'sync_alt';
      log.cor = 'primary';
      break;

    case TipoLogOportunidade.AtualizaouAtividade:
    case TipoLogOportunidade.AtualizaouOportunidade:
      log.icone = 'edit';
      log.cor = 'primary';
      break;

    case TipoLogOportunidade.ExcluiuAtividade:
    case TipoLogOportunidade.ExcluiuOportunidade:
      log.icone = 'close';
      log.cor = 'danger';
      break;

    case TipoLogOportunidade.FinalizouAtividade:
      log.icone = 'done';
      log.cor = 'success';
      break;

    case TipoLogOportunidade.Ganhou:
      log.icone = 'emoji_events';
      log.cor = 'success';
      break;

    case TipoLogOportunidade.InseriuAtividade:
    case TipoLogOportunidade.InseriuOportunidade:
      log.icone = 'add';
      log.cor = 'info';
      break;

    case TipoLogOportunidade.Perdeu:
      log.icone = 'sentiment_very_dissatisfied';
      log.cor = 'danger';
      break;

    case TipoLogOportunidade.CongelouOportunidade:
      log.icone = 'ac_unit';
      log.cor = 'gelo';
      break;

    case TipoLogOportunidade.Reabriu:
    case TipoLogOportunidade.ReativouAtividade:
      log.icone = 'undo';
      log.cor = 'primary';
      break;

    default:
      break;
    }
  }
}
